import { supabase } from "@/integrations/supabase/client";

export const PROPERTY_BUCKET = "property-images";

// Signed URL cache (path -> { url, expiresAt })
const urlCache = new Map<string, { url: string; expiresAt: number }>();
const EXPIRES_IN = 60 * 60 * 24 * 7; // 7 days

export type ImageTransform = { width?: number; quality?: number };

export async function getImageUrl(path: string, transform?: ImageTransform): Promise<string> {
  if (!path) return "";
  // If already a full URL, return as-is
  if (path.startsWith("http://") || path.startsWith("https://")) return path;

  const key = transform ? `${path}|${transform.width ?? ""}|${transform.quality ?? ""}` : path;
  const cached = urlCache.get(key);
  if (cached && cached.expiresAt > Date.now() + 60_000) return cached.url;

  const { data, error } = await supabase.storage
    .from(PROPERTY_BUCKET)
    .createSignedUrl(path, EXPIRES_IN, transform ? { transform } : undefined);
  if (error || !data) return "";
  urlCache.set(key, { url: data.signedUrl, expiresAt: Date.now() + EXPIRES_IN * 1000 });
  return data.signedUrl;
}


export async function uploadPropertyImage(propertyId: string, file: File): Promise<string> {
  const ext = file.name.split(".").pop()?.toLowerCase() || "jpg";
  const path = `${propertyId}/${crypto.randomUUID()}.${ext}`;
  const { error } = await supabase.storage
    .from(PROPERTY_BUCKET)
    .upload(path, file, { cacheControl: "31536000", upsert: false, contentType: file.type });
  if (error) throw error;
  return path;
}

export async function deletePropertyImage(path: string): Promise<void> {
  if (!path || path.startsWith("http")) return;
  await supabase.storage.from(PROPERTY_BUCKET).remove([path]);
  urlCache.delete(path);
}
